module.exports = __webpack_public_path__ + "static/media/pauls_place.8771a99c.png";